import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import PhoneIcon from '../../../../../../assets/svg/PhoneIcon';
import { EmailIcon } from '../../../../../../assets/svg/stop-details/EmailIcon';
import { ExternalIDIcon } from '../../../../../../assets/svg/stop-details/ExternalIDIcon';
import { LabelIcon } from '../../../../../../assets/svg/stop-details/LabelIcon';
import { OptionsIcon } from '../../../../../../assets/svg/stop-details/OptionsIcon';
import { PlaceIcon } from '../../../../../../assets/svg/stop-details/PlaceIcon';
import { ReferencePersonIcon } from '../../../../../../assets/svg/stop-details/ReferencePersonIcon';
import { RequiresIcon } from '../../../../../../assets/svg/stop-details/RequiresIcon';
import { StringIcon } from '../../../../../../assets/svg/stop-details/StringIcon';
import { TimeIcon } from '../../../../../../assets/svg/stop-details/TimeIcon';
import { VolumeIcon } from '../../../../../../assets/svg/stop-details/VolumeIcon';
import { WeightIcon } from '../../../../../../assets/svg/stop-details/WeightIcon';
import WebIcon from '../../../../../../assets/svg/WebIcon';
import { ProjectDriversFieldTypes } from '../../../../../../domain/stop/Stop';

interface StopDetailsFieldProps {
  id: string;
  typeItem: ProjectDriversFieldTypes;
}

export const StopDetailsImageByType = ({ typeItem, id }: StopDetailsFieldProps) => {
  const iconProps = {
    style: { height: `15px`, width: `15px`, paddingRight: `5px` },
    color: RoutalPalette.secondary00,
  };
  const renderImageByType = () => {
    switch (id) {
      case `label`:
        return <LabelIcon {...iconProps} />;
      case `external_id`:
        return <ExternalIDIcon {...iconProps} />;
      case `reference_person`:
        return <ReferencePersonIcon {...iconProps} />;
      case `phone`:
        return <PhoneIcon {...iconProps} />;
      case `location_details`:
      case `location`:
        return <PlaceIcon {...iconProps} />;
      case `email`:
        return <EmailIcon {...iconProps} />;
      case `weight`:
        return <WeightIcon {...iconProps} />;
      case `volume`:
        return <VolumeIcon {...iconProps} />;
      case `website`:
        return <WebIcon {...iconProps} />;
      case `requirements`:
        return <RequiresIcon {...iconProps} />;
      default:
        break;
    }
    switch (typeItem) {
      case `string`:
      case `boolean`:
      case `number`:
        return <StringIcon {...iconProps} />;
      case `time`:
      case `time_window`:
        return <TimeIcon {...iconProps} />;
      case `multiselect`:
      case `select`:
        return <OptionsIcon {...iconProps} />;
      default:
        return null;
    }
  };

  return <Grid container>{renderImageByType()}</Grid>;
};
